import type { ChauffeurPage } from "../slug-chauffeur";

import heroImage from "@/assets/images/chauffeur/events/event-soir.png";

const evenements: ChauffeurPage = {
  slug: "evenements",
  title: "Chauffeur événements – VTC & logistique",
  subtitle: "Navettes, VIP, roadshows, séminaires à Cannes et alentours.",
  keywords: ["chauffeur événements", "vtc événements"],
  hero: {
    title: "Chauffeurs pour événements",
    subtitle: "Coordination et accueil premium.",
    keywords: ["logistique événements", "chauffeur VIP"],
    imageSrc: heroImage.src,
    imageAlt: "Chauffeurs pour événements",
    badges: ["Chef de projet", "Parc adaptable", "Itinéraires optimisés"],
  },
  benefits: {
    heading: "Avantages pour vos événements",
    items: [
      { title: "Chef de projet", description: "Coordination dédiée sur site." },
      { title: "Parc adaptable", description: "Berline, SUV, Van, bus." },
      {
        title: "Itinéraires optimisés",
        description: "Pour des flux sans friction.",
      },
    ],
  },
  services: {
    heading: "Cas d’usage",
    services: [
      {
        title: "Congrès & salons",
        text: "Navettes et accueil d’invités à Cannes (Palais des Festivals).",
      },
      { title: "Mariages", text: "Déplacements coordonnés des convives." },
    ],
  },
  locations: {
    heading: "Lieux couverts",
    items: [{ name: "Nice" }, { name: "Cannes" }, { name: "Monaco" }],
  },
  generic: {
    heading: "Coordination sur site",
    subheading: "Un point de contact unique et réactif à Cannes.",
    paragraphs: [
      "Nous orchestrons les flux de vehicules et d'invites pour eviter toute attente pendant vos evenements.",
      "Ce service convient aux congres, lancements de produit, mariages et operations VIP avec des contraintes de timing elevees.",
      "Avec un pilotage centralise, vous conservez une vision claire de chaque rotation et de chaque prise en charge.",
    ],
    bullets: ["Chef de projet", "Brief chauffeurs", "Tableau de marche"],
  },
  process: {
    heading: "Methodologie evenementielle",
    steps: [
      "Audit des flux passagers et des points de prise en charge.",
      "Construction du plan transport (vehicules, rotations, priorites).",
      "Brief operationnel chauffeurs et coordination terrain.",
      "Suivi en direct et ajustements pendant l'evenement.",
    ],
  },
  faq: [
    {
      q: "Combien de vehicules pouvez-vous mobiliser pour un evenement ?",
      a: "Le dimensionnement depend du volume. Nous adaptons la flotte selon vos contraintes et vos horaires.",
    },
    {
      q: "Avez-vous un interlocuteur unique pendant l'evenement ?",
      a: "Oui, un referent operationnel pilote la coordination pour simplifier vos echanges.",
    },
    {
      q: "Pouvez-vous gerer des invites VIP et des navettes standard en parallele ?",
      a: "Oui, nous separons les flux pour garantir confidentialite, ponctualite et confort.",
    },
  ],
  relatedLinks: [
    {
      label: "La voiture des mariés, avec ou sans chauffeur",
      href: "/chauffeur/voiture-mariage-cannes",
    },
    {
      label: "Chauffeur pendant le Festival de Cannes",
      href: "/chauffeur/festival-de-cannes",
    },
    { label: "Chauffeur d'affaires au MIPIM", href: "/chauffeur/mipim" },
    { label: "Chauffeur d'affaires au MIPCOM", href: "/chauffeur/mipcom" },
    {
      label: "Chauffeur pendant Cannes Lions",
      href: "/chauffeur/cannes-lions",
    },
    { label: "Chauffeur pendant Canneseries", href: "/chauffeur/canneseries" },
    { label: "Chauffeur pendant le TFWA", href: "/chauffeur/tfwa-cannes" },
    {
      label: "Chauffeur au Cannes Yachting Festival",
      href: "/chauffeur/cannes-yachting-festival",
    },
    {
      label: "Chauffeur pendant le Grand Prix de Monaco",
      href: "/chauffeur/grand-prix-de-monaco",
    },
    {
      label: "Chauffeur pendant le Monaco Yacht Show",
      href: "/chauffeur/monaco-yacht-show",
    },
    { label: "Chauffeur pendant Jazz a Juan", href: "/chauffeur/jazz-a-juan" },
    { label: "Transferts avec chauffeur à Cannes", href: "/chauffeur/cannes" },
    { label: "Chauffeur entreprise", href: "/chauffeur/entreprise" },
    { label: "Contacter l'equipe logistique", href: "/contact" },
    {
      label: "Voiture de cérémonie à Cannes",
      href: "/chauffeur/voiture-mariage-cannes",
    },
  ],
  cta: {
    title: "Parlez-nous de votre événement",
    text: "Nous proposons une logistique sur-mesure et réactive.",
    primaryHref: "/contact",
    primaryLabel: "Obtenir une proposition",
  },
  seo: {
    title: "Chauffeur pour événements à Cannes, Nice et Monaco",
    description:
      "Festival de Cannes, MIPIM, Cannes Lions, Grand Prix de Monaco : chauffeur dédié dès 240 € les 3 heures, navettes invités jusqu'à 16 places.",
    canonical: "/chauffeur/evenements",
  },
};

export default evenements;
